const updates = [
  {
    id: 1,
    date: '2026-07-31',
    title: '《暗夜追踪》高清版本已上线',
    desc: '年度悬疑烧脑神作高清资源更新，支持多线路切换播放，观影体验再升级。',
    tag: '新片上线',
  },
  {
    id: 2,
    date: '2026-07-30',
    title: '暑期档专题页面上线',
    desc: '汇聚今夏最热门院线电影资源，动作、喜剧、动画一网打尽，每周持续更新。',
    tag: '专题',
  },
  {
    id: 3,
    date: '2026-07-28',
    title: '播放器全面升级至3.0版本',
    desc: '全新播放引擎上线，加载速度提升40%，支持4K超清画质和记忆播放功能。',
    tag: '系统',
  },
  {
    id: 4,
    date: '2026-07-25',
    title: '悬疑推理专题月启动',
    desc: '本月主打悬疑推理类影片，每日推荐一部高分烧脑电影，影迷热议不断。',
    tag: '活动',
  },
  {
    id: 5,
    date: '2026-07-22',
    title: '日韩影视专区资源扩充',
    desc: '新增200+部日韩热门影视资源，涵盖最新剧集、经典电影和人气动画。',
    tag: '更新',
  },
  {
    id: 6,
    date: '2026-07-18',
    title: '经典老片修复计划第二期完成',
    desc: '50部上世纪经典华语电影完成高清修复，画质提升明显，情怀满满。',
    tag: '经典',
  },
  {
    id: 7,
    date: '2026-07-15',
    title: '手机端观影体验优化',
    desc: '移动端全面适配优化，提升小屏观影的界面体验和播放流畅度。',
    tag: '优化',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">最新动态</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">被窝影院的最新更新、活动和功能优化动态</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group relative flex gap-4 pb-6 mb-6 last:mb-0 last:pb-0 border-l-2 border-background-200 pl-6 hover:border-primary-400 transition-colors cursor-pointer"
            >
              <div className="absolute -left-[5px] top-0 w-2.5 h-2.5 rounded-full bg-background-200 group-hover:bg-primary-500 transition-colors"></div>
              <div className="flex-1">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-[10px] font-medium whitespace-nowrap">{item.tag}</span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}